const faq = [
  {
    question: "How does the image generation process work?",
    answer: {
      text: `UE COMIX utilizes advanced AI models trained on vast datasets of sequential artwork. When you provide a text prompt, our system analyzes the semantic meaning and generates a unique image composition tailored to your description. The AI models learn visual styles, concepts, and techniques from the training data to synthesize new, original artwork.`,
    },
    layout: ["text"],
  },
  {
    question: "Can I use images for commercial purposes?",
    answer: {
      text: `Yes, you can use images generated by UE COMIX for both personal and commercial projects. However, it's important to comply with any applicable laws and regulations regarding AI-generated content. We recommend reviewing our Terms of Service for full details on permitted uses.`,
    },
    layout: ["text"],
  },
  {
    question: "Who owns the images generated with UE COMIX?",
    answer: {
      text: `At UE COMIX, we believe in empowering creators and providing clear guidelines regarding intellectual property rights. When you generate images using our platform, you retain full ownership and intellectual property rights over the final output.`,
    },
    layout: ["text"],
  },
  {
    question: "What image formats and resolutions are supported?",
    answer: {
      text: `We currently generate images in PDF & PNG format with a maximum resolution of 1792x1024 pixels. This resolution is suitable for most digital applications, including web graphics and social media. If you require higher resolutions for print or other purposes, please let us know, and we'll consider expanding our capabilities.`,
    },
    layout: ["text"],
  },
  {
    question: "How can I get the best results when using UE COMIX?",
    answer: {
      text: `To achieve optimal results with our platform, we recommend providing detailed and specific text prompts that describe the desired comic artwork. Consider including information about characters, settings, actions, visual styles, and any other relevant details. The more context you provide, the better the AI can interpret and generate an accurate representation of your vision.`,
    },
    layout: ["text"],
  },
  {
    question: "Why don't you offer refunds for credits and subscriptions?",
    answer: {
      text: `UE COMIX credits are non-refundable once purchased. This policy helps ensure the sustainability of our service by preventing abuse and maintaining a stable ecosystem. When you purchase credits, you're contributing to the ongoing development, maintenance, and computing resources required to run the platform. We strive to provide transparent pricing and a high-quality experience to make your investment worthwhile.`,
    },
    layout: ["text"],
  },
  {
    question: "What is the UE COMIX Affiliate Program, and how does it work?",
    answer: {
      text: [
        "The UE COMIX Affiliate Program is an opportunity for creators, influencers, and enthusiasts to earn rewards by promoting our AI-powered comic art generation platform to their audience.",
        "As an affiliate, you'll receive a unique referral link that you can share across your social media channels, website, or other platforms. When someone signs up for a paid UE COMIX account using your referral link, you'll earn a commission on their initial purchase and any subsequent subscriptions or credit purchases they make.",
        "Our affiliate commissions are competitive, typically ranging from 10% to 25% of the referred customer's spending. The exact commission rate depends on your affiliate tier, which is determined by your overall referral performance.",
        "In addition to earning commissions, top-performing affiliates may be eligible for exclusive benefits, such as early access to new UE COMIX features, promotional merchandise, and potential opportunities for collaboration or sponsored content.",
        "To become a UE COMIX Affiliate, simply visit our Affiliate Program page, review the terms and conditions, and complete the application form. Our team will review your application and, upon approval, provide you with your unique referral link and resources to help you promote UE COMIX effectively.",
      ],
    },
    layout: ["text"],
  },
];

export default faq;
